import { ObjectWrapper } from '../../wrappers/object.wrapper'

export class EditorInputObj {
    objectWrapper: ObjectWrapper;
    subObject: any;
    subObjectCopy: any;
    subObjects: Array<any>;
    subObjectsCopy: Array<any>;
    streamObj: any;
    fwd_Lnk_Obj_Id: number;

    valueField: string;
    valid_CdField: string;
    srt_OrderField: string;

    name: string;
    datatypeName: string;
    typeName: string;
    label: string;

    objTypCode: string;
    length: number;

    exprVal: string;

    isEmptyValid: boolean;
    fromTransform: boolean;
    fromDesign: boolean;
    fromJob: boolean;
    fromStream: boolean;
    fromProjectParam: boolean;
    fromFunction: boolean;

    fromDblClickLnk: boolean;
    fromStreamLnk: boolean;
    fromSCD: boolean;
    fromSch: boolean;

    transform_Ids: Array<number>;
    dropdownList: Array<any>;
    level1Items: Array<any>;
    level2Items: Array<any>;

    dBSeqObjects: Array<any>;
    uDFObjects: Array<any>;
    dBFunObjects: Array<any>;
    dobjObjects: Array<any>;
    databaseFunctions: Array<any>;
    runtimeStatus: Array<any>;
    runtimeStatistics: Array<any>;
    carryForwardParams: Array<any>;

    carryForwardAttributes: Array<any>;
    carryForwardAttributesNamesList: Array<any>;
    valid_Cd: string;
    isDist: boolean;

    constructor() {
        this.transform_Ids = new Array<number>();
        this.dropdownList = new Array<any>();

        this.level1Items = new Array<any>();
        this.level2Items = new Array<any>();

        this.carryForwardAttributes = new Array<any>();
        this.carryForwardAttributesNamesList = new Array<any>();
        this.carryForwardParams = new Array<any>();
        this.dBSeqObjects = new Array<any>();
        this.uDFObjects = new Array<any>();
        this.dBFunObjects = new Array<any>();
        this.dobjObjects = new Array<any>();
        this.databaseFunctions = new Array<any>();
        this.runtimeStatus = new Array<any>();
        this.runtimeStatistics = new Array<any>();
        this.valid_Cd = 'InV_COND';
        this.isDist = false;
        this.setDefaults();
    }

    setDefaults(): void {
        this.objectWrapper = new ObjectWrapper();

        this.subObject = {};
        this.subObjects = new Array<any>();
        this.subObjectsCopy = new Array<any>();
        this.subObjectCopy = new Array<any>();
        this.valueField = '';
        this.valid_CdField = '';
        this.srt_OrderField = '';
        this.name = '';
        this.datatypeName = '';
        this.objTypCode = '';
        this.length = 0;

        this.exprVal = "";

        this.fromTransform = false;
        this.fromDesign = false;
        this.fromJob = false;
        this.fromStream = false;
        this.fromProjectParam = false;
        this.fromFunction = false;

        this.isEmptyValid = false;
        this.fromDblClickLnk = false;
        this.fromStreamLnk = false;
        this.fromSCD = false;
        this.fromSch = false;

        this.typeName = '';
        this.label = '';
        this.valid_Cd = 'InV_COND';
    }
}